import { render, staticRenderFns } from "./actFemaleRules.vue?vue&type=template&id=666917a2&scoped=true"
import script from "./actFemaleRules.vue?vue&type=script&lang=js"
export * from "./actFemaleRules.vue?vue&type=script&lang=js"
import style0 from "./actFemaleRules.vue?vue&type=style&index=0&id=666917a2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "666917a2",
  null
  
)

export default component.exports